import Model from './Model';

export default class extends Model {
  static data() {
    return {
      id: '',
      name: '',
      location: {
        lat: '',
        lng: '',
        name: '',
      },
      description: '',
      manager_id: '',
      contributed_users: '',
    };
  }

  async findById(id) {
    let url = `/projects/${id}?` + this.getParamsAsQueryParam();
    return this.getPromise(url).catch((error) =>
      $showError(
        error.response.data.message || 'something went wrong!',
        'fetch-projects'
      )
    );
  }

  async get() {
    let url = '/projects?' + this.getParamsAsQueryParam();
    return this.getPromise(url).catch((error) =>
      $showError(
        error.response.data.message || 'something went wrong!',
        'fetch-projects'
      )
    );
  }

  async getMinimal(params = {}) {
    const queryParams = params.tourism_operator_id
      ? 'tourism_operator_id=' + params.tourism_operator_id
      : '';
    let url = '/projects/minimal?' + queryParams;
    return this.getPromise(url).catch((error) =>
      $showError(
        error.response.data.message || 'something went wrong!',
        'fetch-minimal-projects'
      )
    );
  }

  async getContributedUser(id) {
    let url = `/projects/${id}/contributions?` + this.getParamsAsQueryParam();
    return this.getPromise(url).catch((error) =>
      $showError(
        error.response.data.message || 'something went wrong!',
        'fetch-contributors'
      )
    );
  }

  async getLeastContributed() {
    let url = '/projects/leastcontributed?' + this.getParamsAsQueryParam();
    return this.getPromise(url).catch((error) =>
      $showError(
        error.response.data.message || 'something went wrong!',
        'fetch-projects'
      )
    );
  }

  async graduate(id) {
    let url = `/projects/${id}/graduate`;
    return this.postPromise(url).catch((error) => {
      $showError(
        error.response.data.message || 'something went wrong!',
        'graduate-project'
      );
    });
  }

  async payout(data) {
    let url = `/projects/${data.project_id}/payout`;
    return this.postPromise(url, {
      amount: data.amount,
      currency_code: 'USD',
    }).catch((error) => {
      $showError(
        error.response.data.message || 'something went wrong!',
        'payout-project'
      );
    });
  }

  async save(project) {
    if (project.id) {
      let url = `/projects/${project.id}`;
      return this.patchPromise(url, project);
    }
    return this.postPromise(`/projects`, project);
  }

  async delete(id) {
    let url = `/projects/${id}`;
    return this.deletePromise(url).catch((error) =>
      $showError(
        error.response.data.message || 'something went wrong!',
        'delete-project'
      )
    );
  }
}
